const faqs = [
  {
    q: '樱花漫画网有哪些类型的漫画？',
    a: '樱花漫画网涵盖韩漫、日漫、国漫三大品类，包括热血冒险、浪漫恋爱、悬疑推理、搞笑日常、奇幻异世界、都市职场等多种题材，满足不同读者的阅读偏好。',
  },
  {
    q: '樱花漫画的「下拉式阅读」是什么意思？',
    a: '下拉式阅读是指整部漫画以连续长图的形式呈现，读者只需向下滑动即可无缝阅读全部章节，无需反复点击「下一页」加载，阅读体验流畅自然，特别适合手机端追漫。',
  },
  {
    q: '所有漫画都是免费的吗？',
    a: '是的，樱花漫画网上的所有漫画资源均为免费阅读，无需注册会员或付费解锁。我们致力于为漫画爱好者提供无障碍的阅读体验，让好作品被更多人看到。',
  },
  {
    q: '如何追更连载中的漫画？',
    a: '你可以通过收藏功能将喜爱的漫画加入书架，当作品更新时系统会第一时间提醒你。同时排行榜和最新动态板块也会展示近期更新的热门作品，帮你不错过任何精彩。',
  },
  {
    q: '樱花漫画支持哪些设备阅读？',
    a: '樱花漫画网采用响应式设计，完美适配电脑、平板和手机浏览器。无论你使用什么设备，都能获得舒适的下拉式阅读体验。此外我们还提供移动端专属入口，阅读更便捷。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            你可能想了解
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-secondary-100 text-secondary-600 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}